"use client"

import { FC, useMemo } from "react"
import { services as staticServices } from '@/src/utils/servicesHelper'
import { useContent } from "@/src/context/ContentContext"

const Services: FC = () => {
  const { services } = useContent()

  const items = useMemo(() => {
    return staticServices.map((svc, i) => ({
      ...svc,
      title: services.items[i]?.title ?? svc.title,
      description: services.items[i]?.description ?? svc.description,
    }))
  }, [services.items])

  return (
    <section
      id="services"
      className="py-8 lg:py-4 min-h-screen flex items-center bg-gradient-to-b from-[#1e2126] via-[#181b20] to-[#111216]"
      aria-labelledby="services-title"
    >
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 id="services-title" className="text-3xl lg:text-4xl font-semibold text-white mb-6">
            {services.sectionTitle}
          </h2>
        </div>
        <ul className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {items.map((service) => {
            const IconComponent = service.icon
            return (
              <li key={service.id} className="group transition-transform hover:-translate-y-1">
                <div
                  className="bg-[#0d0e10] p-6 rounded-2xl border border-[#1a1b1f] group-hover:border-[#2a2b2f] transition-all duration-300 shadow-[0_0_4px_#070708] hover:shadow-[0_0_8px_#121316] h-full flex flex-col justify-between items-center"
                  aria-label={`Послуга: ${service.title}`}
                >
                  <div className="mb-4 rounded-xl flex items-center justify-center w-20 h-20 bg-[#141518] group-hover:bg-[#1e1f22] transition-colors">
                    <IconComponent
                      className="w-10 h-10 text-white"
                      aria-hidden="true"
                      focusable="false"
                    />
                  </div>
                  <h3 className="text-base font-medium text-white mb-2 leading-tight text-center">
                    {service.title}
                  </h3>
                  <p className="font-light text-sm text-gray-300 text-center">
                    {service.description}
                  </p>
                </div>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}

export default Services
